import React from "react";
import useApiProgress from "../hooks/useApiProgress";
import { CircularLoader } from "../components/loader";

export default function DemoPage() {
  const { progress, isLoading, callApi } = useApiProgress();

  const fetchData = async () => {
    await callApi({
      method: "GET",
      url: "http://localhost:5050/big-data",
    });
  };

  return (
    <div className="p-10 space-y-5">
      <button
        onClick={fetchData}
        className="px-5 py-3 bg-blue-600 text-white rounded-xl"
      >
        Fetch Big Data (Test)
      </button>

      {isLoading && <CircularLoader progress={progress} />}
    </div>
  );
}